import { ref, computed, watch, onBeforeUnmount } from 'vue';
import { WHATSAPP_MEDIA_FORMATS } from '../constants/whatsappTemplateTypes';

const detectFormat = file => {
  if (!file) return null;
  const type = file.type || '';
  if (type.startsWith('image/')) return WHATSAPP_MEDIA_FORMATS.IMAGE;
  if (type.startsWith('video/')) return WHATSAPP_MEDIA_FORMATS.VIDEO;
  if (type === 'application/pdf') return WHATSAPP_MEDIA_FORMATS.DOCUMENT;
  return null;
};

/**
 * Tracks the file picked for a template media header: its WhatsApp header format and
 * an object URL for the phone preview, revoked when replaced or when the step unmounts.
 * @param {import('vue').Ref<File|null>} fileRef
 */
export function useWhatsappMediaHeader(fileRef) {
  const previewUrl = ref(null);

  const format = computed(() => detectFormat(fileRef.value));
  const previewMediaType = computed(() => format.value?.toLowerCase() || null);

  const revokePreview = () => {
    if (previewUrl.value) {
      URL.revokeObjectURL(previewUrl.value);
      previewUrl.value = null;
    }
  };

  watch(
    fileRef,
    file => {
      revokePreview();
      if (file) {
        previewUrl.value = URL.createObjectURL(file);
      }
    },
    { immediate: true }
  );

  onBeforeUnmount(() => revokePreview());

  return { format, previewUrl, previewMediaType };
}
